import { Link } from "react-router-dom";
import PreviewMode from "../preview/PreviewMode";
import ProjectInExplore from "./ProjectInExplore";

function ExploreListProject({
  projects,
  handleLodingNewproject,
  isClose,
  handleOpenCloseList,
}) {
  return (
    <div
      className={`p-0  border-end position-absolute z-2 bg-white sideBar shadow-sm ${
        isClose ? `close` : "open"
      }`}
      data-aos="fade-right"
      style={{ height: "100vh", width: "300px" }}
    >
      <span
        className={`position-absolute end-0 p-3 px-1 toggle-list-pr border-1 border shadow-sm ${
          isClose ? `closed` : "opened"
        }`}
        onClick={handleOpenCloseList}
        style={{ transition: ".3s" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          class="bi bi-chevron-left icons-color "
          viewBox="0 0 16 16"
        >
          <path
            fill="#000"
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
          />
        </svg>
      </span>
      <div className="pt-4  ">
        <Link
          to="/"
          className="text-decoration-none d-flex align-items-center opacity-75 gap-1 ps-2"
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            id="left-arrow"
          >
            <path d="m12.3 17.71 6.486 6.486a1 1 0 0 0 1.414-1.414L14.418 17l5.782-5.782a1 1 0 0 0-1.414-1.414L12.3 16.29a.997.997 0 0 0-.292.71c0 .258.096.514.292.71z"></path>
          </svg> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-left icons-color arrow "
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
          </svg>
          <span>Go Back</span>
        </Link>
        <h5 className=" pt-3 px-3">See also : </h5>
        <p className="mb-0 px-3 pb-4" style={{ fontSize: ".9rem" }}>
          You can Browse Views as you like :
        </p>
      </div>

      <PreviewMode />

      <div
        className="d-flex flex-column align-content-center overflow-y-scroll pr-sidebar pb-3"
        style={{ maxHeight: "calc(100vh - 231.6px)" }}
      >
        {projects.map((pr, index) => (
          <ProjectInExplore
            content={pr}
            key={index}
            handleLodingNewproject={handleLodingNewproject}
          />
        ))}
      </div>
    </div>
  );
}

export default ExploreListProject;
